export default __webpack_public_path__ + "static/media/view4_week_province_place_.0c1c8029.csv";